import { IAllocationDimension } from "helpers/allocation-dimension";
import { Validator } from "helpers/validator";
import { formatMessage } from "lib/globalize-util";
import {
    ITargetsData,
    ITargetsDataError,
    RuleType,
    FinancialTargetFilter,
} from "components/product-collection/footer/types";

export class OnlyExistingDeliveriesRule extends Validator<ITargetsData[], ITargetsDataError> {
    allocationDimension: IAllocationDimension;
    idColumn: string;
    doorsColumn: string;
    filters: FinancialTargetFilter[];

    constructor(
        idColumn: string,
        doorsColumn: string,
        allocationDimension: IAllocationDimension,
        filters: FinancialTargetFilter[]
    ) {
        super();
        this.allocationDimension = allocationDimension;
        this.idColumn = idColumn;
        this.doorsColumn = doorsColumn;
        this.filters = filters;
    }

    validate(model: ITargetsData[], errors: ITargetsDataError): ITargetsDataError {
        const unknownIds = [];
        if (!errors[RuleType.OnlyExistingDeliveriesRule] && this.allocationDimension) {
            // DeliveryIDs to check if the delivery exists
            const deliveryIDs = this.allocationDimension.dimension_values.map(
                (dimensionValue) => dimensionValue.external_id
            );
            const filterFields = this.filters.map((filter) => filter.field_name);
            // We are only checking the first row because we assume that all rows have the same columns
            if (model.length) {
                for (const key in model[0]) {
                    if (filterFields.includes(key) || key === this.doorsColumn || key === this.idColumn) {
                        continue;
                    }
                    if (!deliveryIDs.includes(key)) {
                        unknownIds.push(key);
                        continue;
                    }
                }
            }
        }

        const validationErrors = unknownIds.length
            ? {
                  ...errors,
                  [RuleType.OnlyExistingDeliveriesRule]: formatMessage(
                      "Your file contains unrecognized delivery ID(s): |ids|. Please remove these columns from your file.",
                      {
                          ids: unknownIds.join(", "),
                      }
                  ),
              }
            : errors;

        return super.validate(model, validationErrors);
    }
}
